export const TOObTokens = {
  actionColorBgBrand: 'rgba(204, 0, 0, 1)',
  actionColorBgBrandA0: 'rgba(204, 0, 0, 0)',
  actionColorBgBrandA0Inverse: 'rgba(255, 255, 255, 0)',
  actionColorBgBrandAlpha: 'rgba(204, 0, 0, 0.1)',
  actionColorBgBrandAlphaInverse: 'rgba(204, 0, 0, 0.1)',
  actionColorBgBrandHover: 'rgba(165, 1, 1, 1)',
  actionColorBgBrandInverse: 'rgba(230, 0, 0, 1)',
  actionColorBgBrandInverseHover: 'rgba(165, 1, 1, 1)',
  actionColorBgDarkA0: 'rgba(51, 51, 51, 0)',
  actionColorBgDarkA20: 'rgba(51, 51, 51, 0.2)',
  actionColorBgDarkA50: 'rgba(51, 51, 51, 0.5)',
  actionColorBgDisabled: 'rgba(208, 208, 208, 1)',
  actionColorBgDisabledInverse: 'rgba(118, 118, 118, 1)',
  actionColorBgLightA0: 'rgba(255, 255, 255, 0)',
  actionColorBgLightA20: 'rgba(255, 255, 255, 0.2)',
  actionColorBgLightA50: 'rgba(255, 255, 255, 0.5)',
  actionColorBgSecondary: 'rgba(255, 255, 255, 1)',
  actionColorBgSecondaryHover: 'rgba(243, 244, 245, 1)',
  actionColorBgSecondaryInverse: 'rgba(51, 51, 51, 1)',
  actionColorBgSecondaryInverseHover: 'rgba(118, 118, 118, 1)',
  actionColorBgTertiary: 'rgba(51, 51, 51, 1)',
  actionColorBgTertiaryHover: 'rgba(118, 118, 118, 1)',
  actionColorBgTertiaryInverse: 'rgba(255, 255, 255, 1)',
  actionColorBgTertiaryInverseHover: 'rgba(243, 244, 245, 1)',
  actionColorBordersBrand: 'rgba(204, 0, 0, 1)',
  actionColorBordersBrandA0: 'rgba(204, 0, 0, 0)',
  actionColorBordersBrandAlpha: 'rgba(204, 0, 0, 0.1)',
  actionColorBordersBrandHover: 'rgba(165, 1, 1, 1)',
  actionColorBordersBrandInverse: 'rgba(230, 0, 0, 1)',
  actionColorBordersBrandInverseHover: 'rgba(165, 1, 1, 1)',
  actionColorBordersDarkA0: 'rgba(51, 51, 51, 0)',
  actionColorBordersDarkA20: 'rgba(51, 51, 51, 0.2)',
  actionColorBordersDarkA50: 'rgba(51, 51, 51, 0.5)',
  actionColorBordersDisabled: 'rgba(100, 100, 100, 1)',
  actionColorBordersDisabledInverse: 'rgba(100, 100, 100, 1)',
  actionColorBordersLightA0: 'rgba(255, 255, 255, 0)',
  actionColorBordersLightA20: 'rgba(255, 255, 255, 0.2)',
  actionColorBordersLightA50: 'rgba(255, 255, 255, 0.5)',
  actionColorBordersLink: 'rgba(51, 51, 51, 1)',
  actionColorBordersLinkHover: 'rgba(118, 118, 118, 1)',
  actionColorBordersLinkHoverInverse: 'rgba(243, 244, 245, 1)',
  actionColorBordersLinkInverse: 'rgba(255, 255, 255, 1)',
  actionColorBordersSecondary: 'rgba(255, 255, 255, 1)',
  actionColorBordersSecondaryHover: 'rgba(243, 244, 245, 1)',
  actionColorBordersSecondaryInverse: 'rgba(51, 51, 51, 1)',
  actionColorBordersSecondaryInverseHover: 'rgba(118, 118, 118, 1)',
  actionColorBordersTertiary: 'rgba(51, 51, 51, 1)',
  actionColorBordersTertiaryHover: 'rgba(118, 118, 118, 1)',
  actionColorBordersTertiaryInverse: 'rgba(255, 255, 255, 1)',
  actionColorBordersTertiaryInverseHover: 'rgba(243, 244, 245, 1)',
  actionColorTextBrand: 'rgba(255, 255, 255, 1)',
  actionColorTextBrandHover: 'rgba(255, 255, 255, 1)',
  actionColorTextBrandInverse: 'rgba(51, 51, 51, 1)',
  actionColorTextBrandInverseHover: 'rgba(51, 51, 51, 1)',
  actionColorTextDisabled: 'rgba(100, 100, 100, 1)',
  actionColorTextDisabledInverse: 'rgba(206, 212, 217, 1)',
  actionColorTextLink: 'rgba(51, 51, 51, 1)',
  actionColorTextLinkHover: 'rgba(118, 118, 118, 1)',
  actionColorTextLinkHoverInverse: 'rgba(243, 244, 245, 1)',
  actionColorTextLinkInverse: 'rgba(255, 255, 255, 1)',
  actionColorTextLinkSecondary: 'rgba(255, 255, 255, 1)',
  actionColorTextLinkSecondaryHover: 'rgba(243, 244, 245, 1)',
  actionColorTextLinkSecondaryHoverInverse: 'rgba(118, 118, 118, 1)',
  actionColorTextLinkSecondaryInverse: 'rgba(51, 51, 51, 1)',
  actionColorTextLinkTertiary: 'rgba(51, 51, 51, 1)',
  actionColorTextLinkTertiaryHover: 'rgba(118, 118, 118, 1)',
  actionColorTextLinkTertiaryHoverInverse: 'rgba(243, 244, 245, 1)',
  actionColorTextLinkTertiaryInverse: 'rgba(255, 255, 255, 1)',
  actionColorTextSecondary: 'rgba(51, 51, 51, 1)',
  actionColorTextSecondaryHover: 'rgba(118, 118, 118, 1)',
  actionColorTextSecondaryInverse: 'rgba(255, 255, 255, 1)',
  actionColorTextSecondaryInverseHover: 'rgba(243, 244, 245, 1)',
  actionColorTextTertiary: 'rgba(255, 255, 255, 1)',
  actionColorTextTertiaryHover: 'rgba(243, 244, 245, 1)',
  actionColorTextTertiaryInverse: 'rgba(51, 51, 51, 1)',
  actionColorTextTertiaryInverseHover: 'rgba(118, 118, 118, 1)',
  bgColorAlphaBrandA0: 'rgba(51, 51, 51, 0)',
  bgColorAlphaBrandPrimary: 'rgba(51, 51, 51, 0.1)',
  bgColorAlphaDarkA0: 'rgba(51, 51, 51, 0)',
  bgColorAlphaDarkA20: 'rgba(51, 51, 51, 0.2)',
  bgColorAlphaDarkA50: 'rgba(51, 51, 51, 0.5)',
  bgColorAlphaInverseBrandA0: 'rgba(255, 255, 255, 0)',
  bgColorAlphaInverseBrandPrimary: 'rgba(255, 255, 255, 0.1)',
  bgColorAlphaLightA0: 'rgba(255, 255, 255, 0)',
  bgColorAlphaLightA20: 'rgba(255, 255, 255, 0.2)',
  bgColorAlphaLightA50: 'rgba(255, 255, 255, 0.5)',
  bgColorBaseDefault: 'rgba(255, 255, 255, 1)',
  bgColorBaseInverseDefault: 'rgba(51, 51, 51, 1)',
  bgColorBaseInverseSecondary: 'rgba(118, 118, 118, 1)',
  bgColorBaseInverseTertiary: 'rgba(206, 212, 217, 1)',
  bgColorBaseSecondary: 'rgba(243, 244, 245, 1)',
  bgColorBaseTertiary: 'rgba(216, 216, 216, 1)',
  bgColorBrandInversePrimary: 'rgba(255, 255, 255, 1)',
  bgColorBrandInversePrimaryHover: 'rgba(243, 244, 245, 1)',
  bgColorBrandInverseSecondary: 'rgba(175, 206, 236, 1)',
  bgColorBrandInverseSecondaryHover: 'rgba(228, 242, 247, 1)',
  bgColorBrandInverseTertiary: 'rgba(29, 23, 34, 1)',
  bgColorBrandInverseTertiaryHover: 'rgba(84, 86, 90, 1)',
  bgColorBrandPrimary: 'rgba(51, 51, 51, 1)',
  bgColorBrandPrimaryHover: 'rgba(118, 118, 118, 1)',
  bgColorBrandSecondary: 'rgba(228, 242, 247, 1)',
  bgColorBrandSecondaryHover: 'rgba(175, 206, 236, 1)',
  bgColorBrandTertiary: 'rgba(239, 236, 242, 1)',
  bgColorBrandTertiaryHover: 'rgba(239, 236, 242, 1)',
  bgColorFunctionalDisabled: 'rgba(208, 208, 208, 1)',
  bgColorFunctionalError: 'rgba(253, 245, 236, 1)',
  bgColorFunctionalInfo: 'rgba(220, 237, 252, 1)',
  bgColorFunctionalInverseDisabled: 'rgba(208, 208, 208, 1)',
  bgColorFunctionalInverseError: 'rgba(23, 23, 23, 1)',
  bgColorFunctionalInverseInfo: 'rgba(245, 245, 245, 1)',
  bgColorFunctionalInverseSuccess: 'rgba(44, 84, 30, 1)',
  bgColorFunctionalInverseWarning: 'rgba(23, 23, 23, 1)',
  bgColorFunctionalSuccess: 'rgba(201, 232, 190, 1)',
  bgColorFunctionalWarning: 'rgba(253, 245, 236, 1)',
  bgColorPromoInverseDefaultG1: 'rgba(230, 0, 0, 1)',
  bgColorPromoDefaultG1: 'rgba(204, 0, 0, 1)',
  bgColorPromoDefaultG2: 'rgba(204, 0, 0, 1)',
  bgColorPromoInverseDefaultG2: 'rgba(230, 0, 0, 1)',
  bgColorPromoInverseSecondaryG1: 'rgba(230, 0, 0, 1)',
  bgColorPromoInverseSecondaryG2: 'rgba(230, 0, 0, 1)',
  bgColorPromoInverseTertiaryG1: 'rgba(230, 0, 0, 1)',
  bgColorPromoInverseTertiaryG2: 'rgba(230, 0, 0, 1)',
  bgColorPromoSecondaryG1: 'rgba(204, 0, 0, 1)',
  bgColorPromoSecondaryG2: 'rgba(204, 0, 0, 1)',
  bgColorPromoTertiaryG1: 'rgba(204, 0, 0, 1)',
  bgColorPromoTertiaryG2: 'rgba(204, 0, 0, 1)',
  bordersColorBrandPrimary: 'rgba(51, 51, 51, 1)',
  bordersColorBrandPrimaryHover: 'rgba(118, 118, 118, 1)',
  bordersColorBrandPrimaryHoverInverse: 'rgba(243, 244, 245, 1)',
  bordersColorBrandPrimaryInverse: 'rgba(255, 255, 255, 1)',
  bordersColorBrandSecondary: 'rgba(243, 244, 245, 1)',
  bordersColorBrandSecondaryHover: 'rgba(216, 216, 216, 1)',
  bordersColorBrandSecondaryHoverInverse: 'rgba(39, 38, 22, 1)',
  bordersColorBrandSecondaryInverse: 'rgba(24, 24, 24, 1)',
  bordersColorBrandTertiary: 'rgba(118, 118, 118, 1)',
  bordersColorBrandTertiaryHover: 'rgba(51, 51, 51, 1)',
  bordersColorBrandTertiaryHoverInverse: 'rgba(51, 51, 51, 1)',
  bordersColorBrandTertiaryInverse: 'rgba(118, 118, 118, 1)',
  bordersColorFunctionalDisabled: 'rgba(118, 118, 118, 1)',
  bordersColorFunctionalDisabledInverse: 'rgba(118, 118, 118, 1)',
  bordersColorFunctionalError: 'rgba(217, 111, 43, 1)',
  bordersColorFunctionalErrorInverse: 'rgba(221, 125, 65, 1)',
  bordersColorFunctionalFocus: 'rgba(0, 0, 0, 1)',
  bordersColorFunctionalFocusInverse: 'rgba(255, 255, 255, 1)',
  bordersColorFunctionalInfo: 'rgba(216, 216, 216, 1)',
  bordersColorFunctionalInfoInverse: 'rgba(255, 255, 255, 1)',
  bordersColorFunctionalSuccess: 'rgba(48, 117, 27, 1)',
  bordersColorFunctionalSuccessInverse: 'rgba(57, 138, 32, 1)',
  bordersColorFunctionalWarning: 'rgba(51, 51, 51, 1)',
  bordersColorFunctionalWarningInverse: 'rgba(255, 255, 255, 1)',
  bordersColorNeutralDefault: 'rgba(51, 51, 51, 1)',
  bordersColorNeutralInverseDefault: 'rgba(255, 255, 255, 1)',
  bordersColorNeutralInverseSecondary: 'rgba(216, 216, 216, 1)',
  bordersColorNeutralInverseTertiary: 'rgba(206, 212, 217, 1)',
  bordersColorNeutralSecondary: 'rgba(216, 216, 216, 1)',
  bordersColorNeutralTertiary: 'rgba(206, 212, 217, 1)',
  textColorBaseDefault: 'rgba(51, 51, 51, 1)',
  textColorBaseInverseDefault: 'rgba(255, 255, 255, 1)',
  textColorBaseInverseSecondary: 'rgba(51, 51, 51, 1)',
  textColorBaseInverseTertiary: 'rgba(235, 233, 228, 1)',
  textColorBaseSecondary: 'rgba(255, 255, 255, 1)',
  textColorBaseTertiary: 'rgba(118, 118, 118, 1)',
  textColorBrandPrimary: 'rgba(51, 51, 51, 1)',
  textColorBrandPrimaryInverse: 'rgba(255, 255, 255, 1)',
  textColorBrandPromo1: 'rgba(255, 255, 255, 1)',
  textColorBrandPromo1Inverse: 'rgba(204, 0, 0, 1)',
  textColorBrandPromo2: 'rgba(204, 0, 0, 1)',
  textColorBrandPromo2Inverse: 'rgba(255, 255, 255, 1)',
  textColorBrandPromo3: 'rgba(204, 0, 0, 1)',
  textColorBrandPromo3Inverse: 'rgba(255, 255, 255, 1)',
  textColorBrandPromo4: 'rgba(255, 255, 255, 1)',
  textColorBrandPromo4Inverse: 'rgba(255, 255, 255, 1)',
  textColorBrandSecondary: 'rgba(51, 51, 51, 1)',
  textColorBrandSecondaryInverse: 'rgba(255, 255, 255, 1)',
  textColorBrandTertiary: 'rgba(255, 255, 255, 1)',
  textColorBrandTertiaryInverse: 'rgba(51, 51, 51, 1)',
  textColorFunctionalDisabled: 'rgba(118, 118, 118, 1)',
  textColorFunctionalDisabledInverse: 'rgba(118, 118, 118, 1)',
  textColorFunctionalError: 'rgba(171, 88, 32, 1)',
  textColorFunctionalErrorInverse: 'rgba(192, 99, 36, 1)',
  textColorFunctionalInfo: 'rgba(51, 51, 51, 1)',
  textColorFunctionalInfoInverse: 'rgba(255, 255, 255, 1)',
  textColorFunctionalInverseLink: 'rgba(255, 255, 255, 1)',
  textColorFunctionalLink: 'rgba(51, 51, 51, 1)',
  textColorFunctionalLinkHover: 'rgba(118, 118, 118, 1)',
  textColorFunctionalLinkHoverInverse: 'rgba(243, 244, 245, 1)',
  textColorFunctionalSuccess: 'rgba(72, 159, 45, 1)',
  textColorFunctionalSuccessInverse: 'rgba(78, 139, 67, 1)',
  textColorFunctionalWarning: 'rgba(51, 51, 51, 1)',
  textColorFunctionalWarningInverse: 'rgba(255, 255, 255, 1)',
  actionBorderStrokeDefault: '0.0625rem',
  actionBorderStrokeHover: '0.125rem',
  actionBorderRadius: '62.4375rem',
  actionMTopSm: '0.5rem',
  actionMBottomSm: '0.5625rem',
  actionMBottomMd: '0.5938rem',
  actionMTopMd: '0.5938rem',
  actionMTopLg: '0.625rem',
  actionMBottomLg: '0.875rem',
  actionMLeftSm: '1rem',
  actionMRightSm: '1rem',
  actionMLeftLg: '1.5rem',
  actionMLeftMd: '1.5rem',
  actionMRightLg: '1.5rem',
  actionMRightMd: '1.5rem',
  actionPSm: '0.25rem',
  actionPLg: '0.5rem',
  actionPMd: '0.5rem',
  bordersRadiusNone: '0rem',
  bordersRadiusXl: '0rem',
  bordersRadiusSm: '0.25rem',
  bordersRadiusMd: '0.5rem',
  bordersRadiusLg: '1rem',
  bordersRadiusRound: '62.4375rem',
  bordersStrokeNone: '0rem',
  bordersStrokeThinnest: '0.0625rem',
  bordersStrokeThin: '0.125rem',
  bordersStrokeMedium: '0.1875rem',
  bordersStrokeStrong: '0.25rem',
  deviceDeskMNone: '0rem',
  deviceDeskMLrSm: '1.5rem',
  deviceDeskMTbSm: '1.5rem',
  deviceDeskMLrBase: '4rem',
  deviceDeskMTbBase: '4rem',
  deviceDeskMTbLg: '5rem',
  deviceDeskMLrLg: '11rem',
  deviceDeskPNone: '0rem',
  deviceDeskPXs: '0.5rem',
  deviceDeskPSm: '1rem',
  deviceDeskPBase: '1.5rem',
  deviceDeskPLg: '2.5rem',
  deviceDeskRRadius: '0.5rem',
  deviceMobMNone: '0rem',
  deviceMobMLrBase: '1rem',
  deviceMobMLrLg: '1rem',
  deviceMobMLrSm: '1rem',
  deviceMobMTbSm: '1rem',
  deviceMobMTbBase: '2rem',
  deviceMobMTbLg: '2.5rem',
  deviceMobPNone: '0rem',
  deviceMobPXs: '0.5rem',
  deviceMobPSm: '1rem',
  deviceMobPBase: '1.5rem',
  deviceMobPLg: '2.5rem',
  deviceMobRRadius: '0.5rem',
  deviceTabMNone: '0rem',
  deviceTabMTbSm: '1rem',
  deviceTabMLrBase: '2rem',
  deviceTabMLrSm: '2rem',
  deviceTabMTbBase: '2rem',
  deviceTabMTbLg: '2.5rem',
  deviceTabMLrLg: '5rem',
  deviceTabPNone: '0rem',
  deviceTabPXs: '0.5rem',
  deviceTabPSm: '1rem',
  deviceTabPBase: '1.5rem',
  deviceTabPLg: '2rem',
  deviceTabRRadiusLandscape: '0.5rem',
  deviceTabRRadiusPortrait: '0.5rem',
  screenSizeMobile: '23.4375rem',
  screenSizeTabletPortrait: '48rem',
  screenSizeTabletLandscape: '64rem',
  screenSizeDesktop: '90rem',
  spacingsNone: '0rem',
  spacingsXs: '0.125rem',
  spacingsSm: '0.25rem',
  spacingsMd: '0.5rem',
  spacingsBase: '1rem',
  spacingsLg: '1.5rem',
  spacingsXl: '2rem',
  spacings2xl: '2.5rem',
  spacings3xl: '4rem',
  spacings4xl: '5rem',
  spacings5xl: '8rem',
  spacingsSpacingEnormous: '11rem',
  text2xlKerning: '0rem',
  text2xlSize: '1.5rem',
  text2xlLineHeight: '1.8rem',
  text3xlKerning: '0rem',
  text3xlSize: '2rem',
  text3xlLineHeight: '2.4rem',
  text4xlKerning: '0rem',
  text4xlSize: '2.5rem',
  text4xlLineHeight: '3rem',
  text5xlKerning: '0rem',
  text5xlSize: '4rem',
  text5xlLineHeight: '4.8rem',
  text6xlKerning: '0rem',
  text6xlSize: '5rem',
  text6xlLineHeight: '6rem',
  text7xlKerning: '0rem',
  text7xlSize: '7.5rem',
  text7xlLineHeight: '9rem',
  textCTABigKerning: '0rem',
  textCTABigSize: '1rem',
  textCTABigLineHeight: '1.2rem',
  textCTAMediumKerning: '0rem',
  textCTAMediumSize: '0.875rem',
  textCTAMediumLineHeight: '1.05rem',
  textCTASmallKerning: '0rem',
  textCTASmallSize: '0.75rem',
  textCTASmallLineHeight: '0.9rem',
  textBaseKernng: '0rem',
  textBaseSize: '1rem',
  textBaseLineHeight: '1.2rem',
  textH1DeskKerning: '0rem',
  textH1DeskSize: '3.5rem',
  textH1DeskLineHeight: '4.2rem',
  textH1MobKerning: '0rem',
  textH1MobSize: '3rem',
  textH1MobLineHeight: '3.6rem',
  textH1TabKerning: '0rem',
  textH1TabSize: '3rem',
  textH1TabLineHeight: '3.6rem',
  textH2DeskKerning: '0rem',
  textH2DeskSize: '2rem',
  textH2DeskLineHeight: '2.4rem',
  textH2MobKerning: '0rem',
  textH2MobSize: '1.75rem',
  textH2MobLineHeight: '2.1rem',
  textH2TabKerning: '0rem',
  textH2TabSize: '1.75rem',
  textH2TabLineHeight: '2.1rem',
  textH3DeskKerning: '0rem',
  textH3DeskSize: '1.75rem',
  textH3DeskLineHeight: '2.1rem',
  textH3MobKerning: '0rem',
  textH3MobSize: '1.5rem',
  textH3MobLineHeight: '1.8rem',
  textH3TabKerning: '0rem',
  textH3TabSize: '1.5rem',
  textH3TabLineHeight: '1.8rem',
  textH4DeskKerning: '0rem',
  textH4DeskSize: '1.25rem',
  textH4DeskLineHeight: '1.5rem',
  textH4MobKerning: '0rem',
  textH4MobSize: '1.125rem',
  textH4MobLineHeight: '1.35rem',
  textH4TabKerning: '0rem',
  textH4TabSize: '1.125rem',
  textH4TabLineHeight: '1.35rem',
  textH5DeskKerning: '0rem',
  textH5DeskSize: '1.125rem',
  textH5DeskLineHeight: '1.35rem',
  textH5MobKerning: '0rem',
  textH5MobSize: '1rem',
  textH5MobLineHeight: '1.2rem',
  textH5TabKerning: '0rem',
  textH5TabSize: '1rem',
  textH5TabLineHeight: '1.2rem',
  textH6DeskKerning: '0rem',
  textH6DeskSize: '1rem',
  textH6DeskLineHeight: '1.2rem',
  textH6MobKerning: '0rem',
  textH6MobSize: '0.875rem',
  textH6MobLineHeight: '1.05rem',
  textH6TabKerning: '0rem',
  textH6TabSize: '0.875rem',
  textH6TabLineHeight: '1.05rem',
  textLgKerning: '0rem',
  textLgSize: '1.125rem',
  textLgLineHeight: '1.35rem',
  textSmKerning: '0rem',
  textSmSize: '0.875rem',
  textSmLineHeight: '1.05rem',
  textXlKerning: '0rem',
  textXlSize: '1.25rem',
  textXlLineHeight: '1.5rem',
  textXsKerning: '0rem',
  textXsSize: '0.75rem',
  textXsLineHeight: '0.9rem',
  brandURL: 'targetoptical.com',
  brandName: 'Target Optical',
  brandingBrandFooter: 'Target Optical',
  brandingBrandHeader: 'Target Optical',
  brandingBrandLogo: 'Target Optical Logo',
  brandingBrandPictogram: 'Target Optical Logo',
  brandingFavicon: 'Target Optical',
  brandingOff: 'Fill',
  brandingProductImage: 'Target Optical',
  text2xlFamily: 'Helvetica for Target',
  text3xlFamily: 'Helvetica for Target',
  text4xlFamily: 'Helvetica for Target',
  text5xlFamily: 'Helvetica for Target',
  text6xlFamily: 'Helvetica for Target',
  text7xlFamily: 'Helvetica for Target',
  textCTABigFamily: 'Helvetica for Target',
  textCTABigWeight: 'bold',
  textCTAMediumFamily: 'Helvetica for Target',
  textCTAMediumWeight: 'bold',
  textCTASmallFamily: 'Helvetica for Target',
  textCTASmallWeight: 'bold',
  textBaseFamily: 'Helvetica for Target',
  textCaseUppercase: 'uppercase',
  textDecorationStrikethrough: 'strikethrough',
  textDecorationUnderlined: 'underline',
  textH1Family: 'Helvetica for Target',
  textH1Weight: 'bold',
  textH2Family: 'Helvetica for Target',
  textH2Weight: 'bold',
  textH3Family: 'Helvetica for Target',
  textH3Weight: 'bold',
  textH4Family: 'Helvetica for Target',
  textH4Weight: 'bold',
  textH5Family: 'Helvetica for Target',
  textH5Weight: 'Regular',
  textH6Family: 'Helvetica for Target',
  textH6Weight: 'bold',
  textLgFamily: 'Helvetica for Target',
  textSmFamily: 'Helvetica for Target',
  textWeightBold: 'Bold',
  textWeightDefault: 'Regular',
  textXlFamily: 'Helvetica for Target',
  textXsFamily: 'Helvetica for Target',
};
